// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCaseSiteResponseModel {
    static getAttributeTypeMap() {
        return GetCaseSiteResponseModel.attributeTypeMap;
    }
}
GetCaseSiteResponseModel.discriminator = undefined;
GetCaseSiteResponseModel.attributeTypeMap = [
    {
        "name": "siteData",
        "baseName": "siteData",
        "type": "SiteModel"
    },
    {
        "name": "pointOfContactData",
        "baseName": "pointOfContactData",
        "type": "Array<SitePointOfContactModel>"
    }
];
//# sourceMappingURL=getCaseSiteResponseModel.js.map